import {Pipe, PipeTransform} from '@angular/core';
import {ProductStatus} from '@services/model/product';

@Pipe({
  name: 'productStateTranslate',
  standalone: true,
})
export class ProductStateTranslate implements PipeTransform {
  transform(val: string): string {
    switch (val) {
      case ProductStatus.created: {
        return 'Angelegt';
      }
      case ProductStatus.approved: {
        return 'Bestätigt';
      }
      case ProductStatus.denied: {
        return 'Abgelehnt';
      }
      case ProductStatus.requested: {
        return 'Angefordert';
      }
      case ProductStatus.invited: {
        return 'Eingeladen';
      }
      case ProductStatus.notInvited: {
        return 'Abgesagt';
      }
      default: {
        return val;
      }
    }
  }
}
